export const EXPORT_MSG = "Translation exported! 🎉 Refer a colleague and earn ₹500 when they subscribe.";
export const FIRST_FEATURE_MSG = "Welcome back! 👋 Enjoying t09n.com? Refer a colleague and earn ₹500 when they subscribe to any paid plan.";
export const MILESTONES = [500, 1000, 5000, 10000];

export function shouldShowExportReferral() {
  try { return localStorage.getItem('referral_export_shown_date') !== new Date().toDateString(); } catch { return false; }
}
export function markExportReferralShown() {
  try { localStorage.setItem('referral_export_shown_date', new Date().toDateString()); } catch {}
}

export function shouldShowFirstFeatureReferral() {
  try { return !sessionStorage.getItem('first_feature_used'); } catch { return false; }
}
export function markFirstFeatureUsed() {
  try { sessionStorage.setItem('first_feature_used', 'true'); } catch {}
}

export function getUnshownMilestone(monthlyUsage) {
  for (const m of MILESTONES) {
    try { if (monthlyUsage >= m && !localStorage.getItem(`referral_milestone_shown_${m}`)) return m; } catch {}
  }
  return null;
}
export function markMilestoneShown(n) {
  try { localStorage.setItem(`referral_milestone_shown_${n}`, 'true'); } catch {}
}
